<template lang="pug">
.card.mb-0
  .card-header
    .row.w-100
      .form-group.col-12.mb-1
        DateRangePicker(:value="dateRange" @update="getData")
      .form-group.col-md-3.col-2.mb-1
        b-input-group(size="sm")
          b-input-group-text(slot="prepend")
            span {{ $t('ui.action_status') }}
          b-form-select(v-model="action_type" @change="getLogList(true)" size="sm")
            option(value="") {{ $t('ui.all') }}
            option(value="FORGOT_PASSWORD") {{ $t('ui.forgot_password') }}
            option(value="RESET") {{ $t("ui.reset") }}
            option(value="STATUS") {{ $t("ui.status") }}
            option(value="UNBLOCK") {{ $t("ui.unblock") }}
            option(value="UPDATE") {{ $t("ui.update") }}
            option(value="UPDATE_PASSWORD") {{ $t("ui.update_password") }}
      .form-group.col-12.mb-1
        SubmitButton(
          :loading="loading"
          icon="fa fa-search"
          :text="$t('ui.search')"
          type="button"
          @click="getLogList(true)"
          variant="primary"
          size="sm"
        )
  .card-body
    .row
      .col-10.mb-1
        b-pagination.float-left(
          size="sm"
          hide-ellipsis
          :total-rows="totalRow"
          :per-page="getPageSize"
          v-model="currentPage"
          @input="changedPage($event)")
      .col-2.mb-1
        b-input-group(:prepend="$t('ui.page_size')" size="sm")
          b-form-select(:options="$store.getters.pageSizeOptions" :value="getPageSize" @input="changedPageSize" size="sm")
      .col-12
        .clusterize-scroll.table-responsive
          table.table.table-sm.table-bordered.table-striped.table-hover.table-align-middle
            thead.thead-light
              tr
                th.text-center(width="3%")
                  span #
                th(width="7%")
                  span(:title="$t('ui.full_name')") {{ $t('ui.full_name') }}
                th(width="7%")
                  span(:title="$t('ui.contact')") {{ $t('ui.contact') }}
                th.text-center(width="7%")
                  span(:title="$t('ui.status')") {{ $t('ui.status') }}
                th.text-center(width="10%")
                  span(:title="$t('ui.action_status')") {{ $t('ui.action_status') }}
                th(width="7%")
                  span(:title="$t('ui.remark')") {{ $t('ui.remark') }}
                th.text-right(width="10%" @click="sortOrder('action_date')")
                  span(:title="$t('ui.action_date')") {{ $t('ui.action_date') }}
                  .float-right
                    i(:class="changeSortKey('action_date')")
            tbody.clusterize-content
              tr(v-if="logList.length == 0")
                td(:colspan="12").text-center
                  span {{ $t('message.no_data_available') }}
              tr(v-for="(item, index) in logList")
                td.text-center
                  span(:title="((currentPage - 1) * getPageSize + index + 1)") {{ ((currentPage - 1) * getPageSize + index + 1) }}
                td
                  span(:title="item.full_name") {{ item.full_name }}
                td
                  span.d-block.small(:title="item.contact_phone") {{ item.contact_phone }}
                  span.d-block.small(:title="item.contact_email") {{ item.contact_email }}
                td.text-center
                  span(:title="item.status" :class="$helpers.badgeClass(item.status)") {{ item.status }}
                td.text-center
                  span {{ item.action_type }}
                  br
                  span {{ item.action_by }}
                td
                  span(:title="item.remark") {{ item.remark }}
                td.text-right
                  span(:title="$moment(item.action_date).format('YYYY-MM-DD, HH:mm:ss')") {{ $moment(item.action_date).format('YYYY-MM-DD, HH:mm:ss') }}
</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton.vue";
import DebounceInput from "@/library/DebounceInput";
import DateRangePicker from "@/library/DateRangePicker.vue";
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css';
import jsonToExcel from "@/library/jsonToExcel.vue";

export default {
  components: {
    SubmitButton,
    DebounceInput,
    DateRangePicker,
    jsonToExcel
  },
  props: {
    currTab: {
      type: String,
      default: ''
    },
    operatorID: {
      type: String,
      default: ''
    },
    memberID: {
      type: String,
      default: ''
    }
  },
  data: () => ({
    loading: false,
    dateRange: {
      startDate: null,
      endDate: null,
    },
    account_id: "",
    action_type: "",
    feedback: {
      success: false,
      status: errorTags.request.failed
    },
    logList: [],
    currentPage: 1,
    totalRow: 0,
    sortKey: "",
    sortType: ""
  }),
  computed: {
    getPageSize() {
      return this.$store.getters.pageSizeMemberLog;
    }
  },
  mounted: function() {},
  destroyed: function() {
    var json = {
      start_date: null,
      end_date: null,
      action_type: '',
    };
    this.$store.dispatch("user/setMemberLogParam", json);
  },
  methods: {
    refresh() {
      if (this.$store.getters.memberLog.action_type != null && this.$store.getters.memberLog.action_type != '') {
        this.action_type = this.$store.getters.memberLog.action_type;
      }
      if (this.$store.getters.memberLog.start_date && this.$store.getters.memberLog.end_date) {
        this.dateRange.startDate = this.$store.getters.memberLog.start_date;
        this.dateRange.endDate = this.$store.getters.memberLog.end_date;
      } else {
        this.dateRange.startDate = this.$moment(new Date).format('YYYY-MM-DD');
        this.dateRange.endDate = this.$moment(new Date).format('YYYY-MM-DD');
      }

      this.getLogList(true);
    },
    setMemberLogParam: function() {
      var json = {
        start_date: this.dateRange.startDate,
        end_date: this.dateRange.endDate,
        action_type: this.action_type,
      };
      this.$store.dispatch("user/setMemberLogParam", json);
    },
    sortOrder(key, type) {
      if (this.sortKey == key)
        this.sortType = this.sortType == 'asc' ? 'desc' : 'asc';
      else {
        this.sortKey = key;
        this.sortType = 'asc';
      }
      this.getLogList(true);
    },
    changeSortKey(key, type) {
      if (this.sortKey != key)
        return 'fas fa-sort';
      else if (this.sortKey == key && this.sortType == 'asc')
        return 'fa fa-sort-up';
      else if (this.sortKey == key && this.sortType == 'desc')
        return 'fa fa-sort-down';
    },
    checkDateRange() {
      if (this.$moment(this.dateRange.endDate).diff(this.$moment(this.dateRange.startDate), 'days') > 31)
        return false;
      else
        return true;
    },
    getData(currentValue) {
      this.dateRange.startDate = this.$moment(currentValue.startDate).format('YYYY-MM-DD');
      this.dateRange.endDate = this.$moment(currentValue.endDate).format('YYYY-MM-DD');
      this.getLogList(true);
    },
    getLogList: function(isSearch) {
      if (this.checkDateRange()) {
        this.setMemberLogParam();
        let url = config.memberLogUrl();

        if (isSearch) this.currentPage = 1;

        var json = {
          action_by: this.$store.getters.loginId,
          auth_token: this.$store.getters.sessionToken,
          start_date: this.dateRange.startDate,
          end_date: this.dateRange.endDate,
          operator_id: this.operatorID,
          member_id: this.memberID,
          action_type: this.action_type,
          sort_key: this.sortKey,
          sort_type: this.sortType,
          page_number: this.currentPage,
          page_size: this.getPageSize
        };

        this.loading = true;
        this.$http.post(url, json).then(
          function(response) {
            this.loading = false;
            // Success
            try {
              if (response) {
                this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

                this.feedback.status = response.data.statusdesc;
                if (this.feedback.success == true) {
                  this.logList = response.data.dt;
                  this.totalRow = this.logList.length > 0 ? this.logList[0].totalrows : 0;
                } else {
                  if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
                }
              }
            } catch (error) {
              this.feedback.success = false;
              this.feedback.status = errorTags.request.failed;
              this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
            }
          },
          function() {
            this.loading = false;
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        );
      }
      else {
        this.totalRow = 0;
        this.logList = [];
        this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error.dateRangeAllowOneMonth"), "error");
      }
    },
    changedPageSize: function(pageSize) {
      if(this.currTab != 'memberlog') return
      this.$store.dispatch("layout/setPageSizeMemberLog", pageSize);
      this.currentPage = 1;
      this.getLogList(true);
    },
    changedPage: function(pageNo) {
      this.currentPage = pageNo;
      this.getLogList();
    },
    handleFailed: function(tag, status) {
      this.$helpers.showDialog(this.$t("ui.combine." + tag), this.$t("error." + status), "error");
    }
  }
};
</script>